import "./Section.scss";
import SectionDialog from "../../../Dialogs/SectionDialog";
import { useState } from "react";
import Button from "../../../../../buttons/Button";
import { buildUrl } from "../../../../../utils/helper";
export default function Section({ props }) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      {
        isOpen &&
        <SectionDialog setOpen={setIsOpen} setBuildArea={props.setBuildArea} editSectionData={{ ...props.section, rowIndex: props.rowIndex }} />
      }
      <div
        ref={props.providedField.innerRef}
        {...props.providedField.draggableProps}
        {...props.providedField.dragHandleProps}
        className={`section-line-container editable`}
      >
        <div className="section-label">
          <span>Začiatok sekcie</span>
          <div className="edit-buttons">
            <Button
              onClick={() => setIsOpen(true)}
              imageUrl={buildUrl("assets/icons/toolbar/edit.svg")}
              title="Nastavenia sekcie"
              className={"section-edit"}
            />
            <Button
              onClick={() => props.deleteRow(props.rowIndex)}
              imageUrl={buildUrl("assets/icons/close.svg")}
              title="Vymazať sekciu"
              className={"section-delete"}
            />
          </div>
        </div>
        {(props.section.lines === "up" || props.section.lines === "both")
          &&
          <div className="section-line">
          </div>
        }
        <div className="section-title">
          {props.section.title}
        </div>
        {(props.section.lines === "down" || props.section.lines === "both")
          &&
          <div className="section-line">
          </div>
        }
      </div>
    </>
  );
}
